import React from 'react';
import { Box } from '@mui/material';

export const AdornmentWrapper = (props: React.PropsWithChildren<any>) => (
  <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>{props.children}</Box>
)
